import styled from "@emotion/styled"

const HeroScrollDescription = styled.p`
  display: block;
  font-weight: 400;
  margin-top: 0;
  color: white;

  ${({ theme }) => theme.breakpoints.down("2xl")} {
    font-size: 20px;
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    font-size: 18px;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    line-height: 28px;
  }

  ${({ theme }) => theme.breakpoints.between("md", "xl")} {
    line-height: 28px;
  }

  ${({ theme }) => theme.breakpoints.between("lg", "xl")} {
    max-width: 440px;
  }

  ${({ theme }) => theme.breakpoints.up("xl")} {
    line-height: 34px;
    max-width: 670px;
  }
`

export default HeroScrollDescription
